import { useTranslation } from 'react-i18next';

import { ReactComponent as Chevron } from '../assets/chevron-down.svg';
import './Filter.scss';
import styles from './Filter.module.scss';

export const Collapsible = ({name, children, onChange, summ, isOpen=true}) => {
  const { t } = useTranslation();

  let content = null;

  if (isOpen) {
    content = (
      <>
        {children}
      </>
    )
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerSecondary} onClick={() => onChange(!isOpen)}>
        <span>
          <span>{t(name)}</span>
          {summ > 0 ? <span className='summ'>{summ}</span> : ''}
        </span>
        <Chevron 
          className={isOpen ? 'chevron-icon open' : 'chevron-icon'}
          onClick={() => onChange(!isOpen)}
        />
      </div>
      {content}
    </div>
  )
}